import "./chunk-HZPPXYZC.mjs";
import "./chunk-QZIHU4VM.mjs";
import {
  Button,
  Card,
  CardGrid,
  ChecklistItem,
  Container,
  Divider,
  DotGrid,
  FeatureCard,
  Footer,
  GradientText,
  Hero,
  HomePage,
  MarketingPage,
  MarketingThemeProvider,
  MetricCard,
  Navbar,
  Pressable,
  PricingCard,
  Section,
  SectionBadge,
  Text,
  TrustedBy,
  useBreakpoint,
  useIsAbove,
  useMarketingTheme
} from "./chunk-7VBGLKOT.mjs";
import {
  marketingTheme
} from "./chunk-OPHPJ2WG.mjs";
import {
  Icon
} from "./chunk-HGGC2VGG.mjs";
import {
  Avatar,
  AvatarBadge,
  AvatarFallback,
  AvatarGroup,
  AvatarStyles,
  ProductPostCard,
  ProductPostCardAnalytics,
  ProductPostCardContent,
  ProductPostCardHeader,
  ProductPostCardIndicators,
  ProductPostCardInsight,
  ProductPostCardMedia,
  ProductPostCardMetrics,
  ProductPostCardSparkline,
  ProductPostCardStyles,
  ProductThemeProvider,
  deriveAvatarInitials,
  useProductTheme
} from "./chunk-C7VCBV5O.mjs";
import {
  productTheme
} from "./chunk-7AV5FO4O.mjs";
import {
  borderWidth,
  brand,
  breakpoints,
  breakpoints2,
  colors,
  colors2,
  durations,
  easings,
  focus,
  fontWeights,
  fonts,
  layout,
  marketing,
  marketingBreakpoints,
  marketingRadii,
  marketingSpacing,
  marketingTypeScale,
  maxWidths,
  motion,
  motion2,
  opacity,
  product,
  productBreakpoints,
  productRadii,
  productSpacing,
  productTypeScale,
  radii,
  radius,
  sectionSpacing,
  semanticDark,
  semanticLight,
  shadows,
  spacing,
  spacing2,
  typoDesktop,
  typoMobile,
  typoTablet,
  typography,
  typography2,
  zIndex
} from "./chunk-RWJTCKM5.mjs";

// src/primitives/Box.tsx
import React from "react";
import { View } from "react-native";
import { jsx } from "react/jsx-runtime";
var Box = React.forwardRef(
  ({
    direction,
    align,
    justify,
    wrap,
    gap,
    padding,
    paddingX,
    paddingY,
    flex,
    bg,
    borderRadius,
    borderWidth: borderWidth2,
    borderColor,
    width,
    height,
    maxWidth,
    minHeight,
    overflow,
    position,
    top,
    bottom,
    left,
    right,
    zIndex: zIndex2,
    opacity: opacity2,
    style,
    ...rest
  }, ref) => {
    const boxStyle = {
      ...direction && { flexDirection: direction },
      ...align && { alignItems: align },
      ...justify && { justifyContent: justify },
      ...wrap && { flexWrap: wrap },
      ...gap !== void 0 && { gap },
      ...padding !== void 0 && { padding },
      ...paddingX !== void 0 && {
        paddingHorizontal: paddingX
      },
      ...paddingY !== void 0 && {
        paddingVertical: paddingY
      },
      ...flex !== void 0 && { flex },
      ...bg && { backgroundColor: bg },
      ...borderRadius !== void 0 && { borderRadius },
      ...borderWidth2 !== void 0 && { borderWidth: borderWidth2 },
      ...borderColor && { borderColor },
      ...width !== void 0 && { width },
      ...height !== void 0 && { height },
      ...maxWidth !== void 0 && { maxWidth },
      ...minHeight !== void 0 && { minHeight },
      ...overflow && { overflow },
      ...position && { position },
      ...top !== void 0 && { top },
      ...bottom !== void 0 && { bottom },
      ...left !== void 0 && { left },
      ...right !== void 0 && { right },
      ...zIndex2 !== void 0 && { zIndex: zIndex2 },
      ...opacity2 !== void 0 && { opacity: opacity2 }
    };
    return /* @__PURE__ */ jsx(View, { ref, style: [boxStyle, style], ...rest });
  }
);
Box.displayName = "Box";

// src/primitives/Spacer.tsx
import { View as View2 } from "react-native";
import { jsx as jsx2 } from "react/jsx-runtime";
var Spacer = ({ size, horizontal }) => /* @__PURE__ */ jsx2(
  View2,
  {
    style: horizontal ? { width: size, height: 1 } : { height: size, width: 1 }
  }
);
Spacer.displayName = "Spacer";
export {
  Avatar,
  AvatarBadge,
  AvatarFallback,
  AvatarGroup,
  AvatarStyles,
  Box,
  Button,
  Card,
  CardGrid,
  ChecklistItem,
  Container,
  Divider,
  DotGrid,
  FeatureCard,
  Footer,
  GradientText,
  Hero,
  HomePage,
  Icon,
  MarketingPage,
  MarketingThemeProvider,
  MetricCard,
  Navbar,
  Pressable,
  PricingCard,
  ProductPostCard,
  ProductPostCardAnalytics,
  ProductPostCardContent,
  ProductPostCardHeader,
  ProductPostCardIndicators,
  ProductPostCardInsight,
  ProductPostCardMedia,
  ProductPostCardMetrics,
  ProductPostCardSparkline,
  ProductPostCardStyles,
  ProductThemeProvider,
  Section,
  SectionBadge,
  Spacer,
  Text,
  TrustedBy,
  brand,
  breakpoints2 as breakpoints,
  colors2 as colors,
  deriveAvatarInitials,
  durations,
  easings,
  fontWeights,
  fonts,
  marketing,
  marketingBreakpoints,
  marketingRadii,
  marketingSpacing,
  marketingTheme,
  marketingTypeScale,
  maxWidths,
  motion2 as motion,
  product,
  productBreakpoints,
  productRadii,
  productSpacing,
  productTheme,
  productTypeScale,
  radii,
  sectionSpacing,
  semanticDark,
  semanticLight,
  shadows,
  spacing2 as spacing,
  borderWidth as stormBorderWidth,
  breakpoints as stormBreakpoints,
  colors as stormColors,
  focus as stormFocus,
  layout as stormLayout,
  motion as stormMotion,
  opacity as stormOpacity,
  radius as stormRadius,
  spacing as stormSpacing,
  typography as stormTypography,
  zIndex as stormZIndex,
  typoDesktop,
  typoMobile,
  typoTablet,
  typography2 as typography,
  useBreakpoint,
  useIsAbove,
  useMarketingTheme,
  useProductTheme
};
//# sourceMappingURL=index.mjs.map